var map = {
	"./Improvements/improvements_01.webp": 406,
	"./Improvements/improvements_02.webp": 559,
	"./Improvements/improvements_03.webp": 20,
	"./Improvements/improvements_04.webp": 237,
	"./Improvements/improvements_05.webp": 837,
	"./Improvements/improvements_06.webp": 995,
	"./Improvements/improvements_07.webp": 152,
	"./Improvements/improvements_08.webp": 593,
	"./Improvements/improvements_09.webp": 838,
	"./Improvements/improvements_10.webp": 228,
	"./Improvements/improvements_11.webp": 463,
	"./Improvements/improvements_12.webp": 470,
	"./Improvements/improvements_13.webp": 878,
	"./Improvements/improvements_14.webp": 344,
	"./Improvements/improvements_15.webp": 107,
	"./Improvements/improvements_16.webp": 458,
	"./LogoFooter.webp": 281,
	"./LogoHeader.webp": 939,
	"./favicon.webp": 772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 307;